<template>
  <section class="assessmentSection protectionLevelOverview">
    <div class="welcomeBackground"></div>
    <div class="pageContent">
      <WelcomeContactCard />
      <div class="pageTitle">Getting started with our process</div>
      <div class="pageText">
        <p>Every system starts with the Essential System. The Essential system helps protect all exterior doors and includes a motion sensor as an interior trap.</p>
        <p>Smart home features and environmental protection can be added to any level you choose.</p>
      </div>
      <continue-button
        :before="handleContinue"
        to="/assessment/protection-level"
        text="Choose a level"
      />
      <div class="startOverSection">
        <a
          href="/assessment/start-over"
          onclick="mixpanel.track('startedOver')"
        >Clear data and start over</a>
      </div>
      <div class="startOverSection">
        Have an account?
        <a href="/assessment/login">Log In</a>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { mapActions, mapState } from "vuex";
import WelcomeContactCard from "../components/WelcomeContactCard.vue";
export default {
  computed: {
    ...mapState([])
  },
  methods: {
    ...mapActions([]),
    handleContinue() {
      axios.post("/ajax/handle-user-welcome", {
        mixpanelId: mixpanel.get_distinct_id(),
        intercomId: Intercom("getVisitorId")
      });
    }
  },
  mounted() {
    if (this.$route.query.startOver) {
      window.localStorage.setItem("lead", "");
    }
  },
  components: {
    WelcomeContactCard
  }
};
</script>

<style lang="css"></style>
